import { z } from 'zod';
import { picklistFilter } from './common/filters';

export const backlogItemsPicklistFilterSchema = z.object({
  backlogTeamId: picklistFilter,
  backlogEstimationId: picklistFilter,
  backlogItemTypeId: picklistFilter,
  backlogItemStatusId: picklistFilter,
});

export const backlogItemsBooleanFilterSchema = z.object({
  needsTeamOrEstimate: z
    .object({
      value: z.boolean().optional(),
    })
    .optional(),
});

export const backlogItemsFilterSearchSchema = z.object({
  ...backlogItemsPicklistFilterSchema.shape,
  ...backlogItemsBooleanFilterSchema.shape,
});

export const isBacklogItemsPicklistFilterKey = (
  key: string,
): key is keyof typeof backlogItemsPicklistFilterSchema.shape => {
  return Object.keys(backlogItemsPicklistFilterSchema.shape).includes(key);
};
